import { setProblemAsCompleted } from "../services/userService";
import * as esprima from 'esprima';


export const useRegexTest = () => {


    async function RegexCheckProblems(studentCode, output, checkboxes, user, lessonID, lessonProblems, adminResolve = false) {
        const problemsArray = Array.isArray(lessonProblems.problems) ? lessonProblems.problems : Object.values(lessonProblems.problems);
        for (const problem of problemsArray) {
            const checkboxKey = `checkbox${problem.problemID}`;
            if (checkboxes[checkboxKey] !== true) {

                let passed = false;


                if (adminResolve) {
                    passed = true;
                    
                // --- TEST CODE STRUCTURE IF expectedCode IS USED ---
                } else if (problem.expectedCode && !problem.expectedOutput) {
                    try {
                        // Parse both student and expected code into AST
                        const studentAST = esprima.parseScript(studentCode);
                        const expectedAST = esprima.parseScript(problem.expectedCode);

                        // Compare ASTs by stringified structure
                        passed = JSON.stringify(studentAST) === JSON.stringify(expectedAST);
                    } catch (err) {
                        console.error("AST comparison failed:", err);
                    }
                } else if (problem.expectedOutput !== null) {
                    let cleanOutput = output.replace(/\r\n/g, '').replace(/\n/g, '').replace(/\\n/g, '').trim();

                    if (cleanOutput === 'No output') {
                        cleanOutput = '';
                    }

                    const safeExpectedOutput = problem.expectedOutput.trim();
                    const cleanedSafeExpectedOutput = safeExpectedOutput.replace(/\r\n/g, '').replace(/\n/g, '').replace(/\\n/g, '').trim();


                    if (cleanedSafeExpectedOutput === '') {
                        // Only pass if output is exactly empty
                        passed = cleanOutput === '';
                    } else {
                        const outputRegex = new RegExp(cleanedSafeExpectedOutput);
                        passed = outputRegex.test(cleanOutput);


                    }

                }

                if (passed) {
                    await setProblemAsCompleted(lessonID, problem.problemID, user.uid, user.role);
                    checkboxes[checkboxKey] = true;
                    // console.log(`✅ Problem ${problem.problemID} passed`);
                } else {
                    checkboxes[checkboxKey] = 'fail';
                    // console.log(`❌ Test failed for ${problem.problemID}`);
                }
                break;

            }
        }
        return checkboxes;
    }


    return { RegexCheckProblems }
}